import styled from 'styled-components';
import { H1, H2, H3, SectionParent } from '../../components/StyledComponents';

import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import tick from '../../assets/v2/Pricing/tick.svg';
import cross from '../../assets/v2/Pricing/cross.svg';

const Section = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #ffffff;
  padding-top: 4rem !important;
  padding-bottom: 5rem !important;
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    /* padding-bottom: 5rem !important; */
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const HeroTitle = styled.div`
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.94;
  letter-spacing: normal;
  color: #151828;
  text-align: center;
  padding-bottom: 1rem;
  @media (max-width: 520px) {
    font-size: 24px;
  }
`;

const TableContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  width: 60%;
  padding-top: 3rem;
  @media (max-width: 800px) {
    width: 100%;
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

const FirstRowHeader = styled.div`
  display: grid;
  grid-column: span 2;
  height: 5rem;
  background-color: #232a57;
  font-size: 21px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  padding: 10px;
  box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.19);
  display: grid;
  align-items: center;
  @media (max-width: 520px) {
    font-size: 14px;
  }
`;
const SecondRowHeader = styled(FirstRowHeader)`
  background-color: #ffffff;
  grid-column: span 1;
  border-radius: 8px 8px 0 0;
  margin-left: -10px;
`;
const ThirdRowHeader = styled(SecondRowHeader)`
  background-color: #ffffff;
  grid-column: span 1;
  border-radius: 8px 8px 0 0;
  margin-left: 10px;
  @media (max-width: 520px) {
    grid-column: span 2;
    font-size: 12px;
  }
`;

const RowContainer = styled.div`
  display: grid;
  grid-column: span 4;
  grid-template-columns: repeat(4, 1fr);
  height: fit-content;
  width: 100%;
  @media (max-width: 520px) {
    grid-column: span 5;
    grid-template-columns: repeat(5, 1fr);
  }
`;

const FirstRowColumn = styled.div`
  display: grid;
  grid-column: span 2;
  align-content: center;
  /* justify-content: center; */
  text-align: left;
  background-color: #232a57;
  padding: 1rem;
  padding-left: 2rem;
  font-size: 15px;
  height: fit-content;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.8;
  letter-spacing: normal;
  border-top: 0.2px solid #4f5475;
  color: #e9ecff;
  height: 100%;
  @media (max-width: 520px) {
    padding-left: 0.5rem;
    line-height: normal;
  }
`;

const SecondRowColumn = styled(FirstRowColumn)`
  display: grid;
  grid-column: span 1;
  background-color: #f4f5fc;
  margin-left: -10px;
  border-top: none;
  box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.19) !important;
  align-content: center;
  justify-content: center;
`;

const ThirdRowColumn = styled(SecondRowColumn)`
  margin-left: 10px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.8;
  letter-spacing: normal;
  color: #9095ab;
  @media (max-width: 520px) {
    font-size: 12px;
    grid-column: span 2;
  }
`;
const HeaderRow = styled.div`
  grid-column: span 4;
  grid-template-columns: repeat(4, 1fr);
  display: grid;
`;
export default class PricingSectionFour extends React.Component<any, any> {
  render() {
    return (
      <Section>
        <HeroTitle>Esper Vs. Traditional MDM </HeroTitle>
        <TableContainer>
          <FirstRowHeader>
            {this.props?.messages?.HomePageEsperVsMDMFeatures}
          </FirstRowHeader>
          <SecondRowHeader style={{ color: '#9568d0' }}>ESPER</SecondRowHeader>
          <ThirdRowHeader style={{ color: '#232a57' }}>
            TRADITIONAL <br />
            MDM
          </ThirdRowHeader>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesDeviceManagement}
            </FirstRowColumn>
            <SecondRowColumn>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <img src={tick} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesCompatible}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              {
                this.props.messages
                  ?.HomePageEsperVsMDMFeaturesCompatibleTraditionalMDM
              }
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesKioskMode}
            </FirstRowColumn>
            <SecondRowColumn>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesPipelines}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesCustomDevice}
            </FirstRowColumn>
            <SecondRowColumn>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesVirtual}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesRemoteDebug}
            </FirstRowColumn>
            <SecondRowColumn>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesOSEnhancement}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesHardwareVendors}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              {this.props?.messages?.HomePageEsperVsMDMFeaturesCustomAndroid}
            </FirstRowColumn>
            <SecondRowColumn
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '0 0 8px 8px',
              }}
            >
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '0 0 8px 8px',
              }}
            >
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
        </TableContainer>
        {/* <TableContainer>
          <FirstRowHeader>FEATURES</FirstRowHeader>
          <SecondRowHeader style={{ color: '#9568d0' }}>ESPER</SecondRowHeader>
          <ThirdRowHeader style={{ color: '#232a57' }}>
            TRADITIONAL <br />
            MDM
          </ThirdRowHeader>
          <RowContainer>
            <FirstRowColumn>Device Management Features</FirstRowColumn>
            <SecondRowColumn>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <img src={tick} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              Compatible with 99% of Android builds
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              Partial Support
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>Secure Kiosk Mode</FirstRowColumn>
            <SecondRowColumn>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              CI/CD Automated Pipelines for App {'&'}Configuration Deployment{' '}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>Custom Device Emulators</FirstRowColumn>
            <SecondRowColumn>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>Virtual Device Lab</FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>Secure Remote Debugging</FirstRowColumn>
            <SecondRowColumn>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              Android OS Enhancement {'&'} Managed OTA Updates{' '}
            </FirstRowColumn>
            <SecondRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn style={{ backgroundColor: '#ffffff' }}>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>Over 35 Validated Hardware Vendors </FirstRowColumn>
            <SecondRowColumn>
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn>
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
          <RowContainer>
            <FirstRowColumn>
              Custom Android Device Development using MediaTek’s IoT platform{' '}
            </FirstRowColumn>
            <SecondRowColumn
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '0 0 8px 8px',
              }}
            >
              <img src={tick} />
            </SecondRowColumn>
            <ThirdRowColumn
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '0 0 8px 8px',
              }}
            >
              <img src={cross} style={{ height: '1rem' }} />
            </ThirdRowColumn>
          </RowContainer>
        </TableContainer>
       */}
      </Section>
    );
  }
}
